import createModel, { Mapped, Optional } from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  ...Mapped({
    key: String,
    value: {
      apiKey: String,
      name: Optional(String),
      description: String,
    },
  }),
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
